import { useQuery } from "@tanstack/react-query";
import type { UseGasConsumptionInput } from "../models/GasConsumption";
import { getGasConsumption } from "../repositories/GasConsumptionRepository";

export const useGasConsumption = ({
	targetId,
	enabled,
	zoneKeys,
	mode,
	period,
	waitForEveryZone = true,
}: UseGasConsumptionInput) => {
	const canonicalZoneKeys =
		zoneKeys === null
			? null
			: [...new Set(zoneKeys)].sort((left, right) => left.localeCompare(right));

	return useQuery({
		queryKey: [
			"gas-consumption",
			targetId,
			canonicalZoneKeys?.join("|") ?? "totals",
			mode,
			period.startUtc.toISOString(),
			period.endUtc.toISOString(),
			waitForEveryZone,
		],
		queryFn: ({ signal }) =>
			getGasConsumption(
				{
					targetId,
					zoneKeys: canonicalZoneKeys,
					mode,
					startUtc: period.startUtc,
					endUtc: period.endUtc,
					waitForEveryZone,
				},
				signal,
			),
		enabled,
		keepPreviousData: true,
		refetchInterval: 60_000,
		refetchOnWindowFocus: true,
		retry: 1,
	});
};
